<template>
  <div class="rtc container">
    <div class="webrtc">
      <a ref="webrtc_link">WebRTC <i ref="webrtc_icon"></i></a>
    </div>
    <div class="sw">
      <a ref="sw_link">ServiceWorker <i ref="sw_icon"></i></a>
    </div>
    <div class="mse">
      <a ref="mse_link">MSE <i ref="mse_icon"></i></a>
    </div>
    <div class="version">
      <a ref="ver_link" style="background: green"></a>
    </div>
    <div class="blank"></div>
  </div>
</template>

<script>
import { isWebRTCSupported } from '../../utils/tools'
// import P2pEngineHls from 'swarmcloud-hls/dist/p2p-engine.min';
export default {
  name: 'WebRTC',
  mounted() {
    if(isWebRTCSupported()) {
      this.$refs.webrtc_icon.className = 'fa fa-check'
      this.$refs.webrtc_link.style.backgroundColor = 'green'
    } else {
      this.$refs.webrtc_icon.className = 'fa fa-close'
      this.$refs.webrtc_link.style.backgroundColor = 'red'
    }

    if(P2pEngineHls.isServiceWorkerSupported()) {
      this.$refs.sw_icon.className = 'fa fa-check'
      this.$refs.sw_link.style.backgroundColor = 'green'
    } else {
      this.$refs.sw_icon.className = 'fa fa-close'
      this.$refs.sw_link.style.backgroundColor = 'red'
    }

    if(P2pEngineHls.isMSESupported()) {
        this.$refs.mse_icon.className = 'fa fa-check'
        this.$refs.mse_link.style.backgroundColor = 'green'
    } else {
        this.$refs.mse_icon.className = 'fa fa-close'
        this.$refs.mse_link.style.backgroundColor = 'red'
    }

    this.$refs.ver_link.innerText = `Version: ${P2PEngineHls.version}`
  }
}
</script>

<style scoped>
  .rtc {
    flex-wrap: wrap;
    margin-top: 50px;
    border-bottom: 1px solid green;
    display: flex;
    justify-content: space-between;
  }
  .blank {
    clear: both;
  }
  a {
    font-size: 1.125rem;
    font-weight: 550;
    padding: 12px 24px;
    outline: none;
    color: #fff;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    letter-spacing: 0.02rem;
    transition: all 300ms linear;
  }
</style>
